import styled from 'styled-components';

export const Container = styled.div`
  &.group-wrapper {
    display: flex;
    flex-direction: column;
    gap: 15px;

    width: 100%;
    min-height: 290px;

    .button {
      margin-top: auto;
    }

    animation: entering 0.5s ease-in;
  }
`;

export const CodeStep = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;

  max-width: 300px;

  margin: 0 auto;

  color: #fff;
  font-size: 1rem;

  text-align: center;

  strong {
    font-size: 1.4rem;
  }

  span {
    margin-top: 25px;
  }
`;

export const Confirmation = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 15px;

  max-width: 325px;
  min-height: 350px;

  padding: 0 15px;

  .confirmation__message {
    display: flex;
    flex-direction: column;
    gap: 15px;

    max-width: 245px;

    font-size: 1.25rem;
    color: var(--blue12);
    b {
      font-weight: bold;
    }
  }

  .confirmation__icon {
    width: 140px;
    height: 120px;

    margin: 0 auto;
  }

  .button {
    margin: 10px 0;

    font-weight: normal;
    text-transform: none;

    box-shadow: 0 3px 6px rgb(0 0 0/ 16%);
  }
`;
